import { useLayoutEffect, useState } from 'react';
import { xsMax } from '../breakpoints';
import { throttle } from '../utils/throttle';
import useEventListener from './use-event-listener';

// Our css declarations rely on the "xs" layout breakpoint
const MOBILE_PORTRAIT_BREAKPOINT_PX = xsMax;

interface WindowSize {
  width: number;
  height: number;
  isMobilePortrait: boolean;
}

function calculate(): WindowSize {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    isMobilePortrait: window.innerWidth <= MOBILE_PORTRAIT_BREAKPOINT_PX,
  };
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>(calculate());

  const handleSize = () => {
    setWindowSize(calculate());

    // Also make the `--vh` CSS variable available
    let vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  useEventListener('resize', throttle(handleSize, 100));

  // Set size at the first client-side load
  useLayoutEffect(() => {
    handleSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return windowSize;
}

export default useWindowSize;
